<div class="tool-run-form-wrapper">
  <form
    [formGroup]="form()"
    class="tool-run-form"
    enctype="multipart/form-data"
    (ngSubmit)="onSubmit()">
    <div class="tool-run-form-inputs">
      @for (input of toolInputs(); track input) {
        <div style="width: 100%; height: 100%">
          @if (!isInputWithMapping(input) || !input.isHidden) {
            <div>
              @switch (input.param.type) {
                @case ('Value') {
                  <app-value-input [form]="form()" [input]="input"></app-value-input>
                }
                @case ('File') {
                  <div>
                    @if (input.param.type === 'File') {
                      <app-file-upload
                        (fileSelectedEvent)="onFileSelect(input.name, $event)"
                        [inputDetails]="input"
                        [isList]="input.isList"
                        [input]="input"
                        [supportedMediaTypes]="input.param.supportedMediaTypes">
                      </app-file-upload>
                    }
                  </div>
                }
                @case ('Table') {
                  <app-table-input [form]="form()" [input]="input"></app-table-input>
                }
              }
            </div>
          }
        </div>
      }
    </div>
    <div
      class="button-wrapper"
      [matTooltip]="
        isTableEditing() ? 'Finish editing the table before running.' : invalidInputs()
      ">
      <button
        cuiButton
        [disabled]="form().invalid || submitting() || isTableEditing()"
        [loading]="submitting()"
        variant="primary"
        type="submit">
        Run
      </button>
    </div>
  </form>
</div>
